// extracted by mini-css-extract-plugin
export default {"option":"QbwQA","option--active":"tci0g","option--link":"e2aqH"};